import type { Program, ProgramWithingsOrderPostContentObjectList } from 'models';
import { useState } from 'react';
import { Flex } from 'ui';
import { Attachments } from 'features/attachments';
import { Subscribe } from '../../../subscribe';
import { Footer } from '../footer';
import { LongTextContent } from '../long-text-content';
import { ProgramTimelineItemHeader } from '../program-timeline-item-header';

type P = {
  'data-test-id'?: string;
  item: ProgramWithingsOrderPostContentObjectList;
  program: Program;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
const ProgramWithingsOrderPostTimelineItem = ({ 'data-test-id': dataTestId, item, program }: P) => {
  const [isSubscribeOpened, setIsSubscribeOpened] = useState(false);

  const isProgramPublished = program.status === 'published';

  return (
    <Flex data-test-id={dataTestId} gap={32} vertical>
      <ProgramTimelineItemHeader item={item} program={program} />

      <LongTextContent
        item={item}
        onCreateOrder={() => {
          setIsSubscribeOpened(true);
        }}
      />

      <Attachments attachments={item.attachments} />

      <Footer isProgramPublished={isProgramPublished} item={item} program={program} />
      <Subscribe
        isOpened={isSubscribeOpened}
        onCancel={() => {
          setIsSubscribeOpened(false);
        }}
        onSuccess={() => {
          setIsSubscribeOpened(false);
        }}
        programId={program.id}
      />
    </Flex>
  );
};

export default ProgramWithingsOrderPostTimelineItem;
